import React, {useEffect, useState} from "react";

const UniversityList = ({onEdit, onEditCRM}) => {
    const [universities, setUniversities] = useState([]);
    const [feedbackMessage, setFeedbackMessage] = useState(null);
    const [error, setError] = useState(null);
    
    // Filter and sort state
    const [searchTerm, setSearchTerm] = useState('');
    const [countryFilter, setCountryFilter] = useState('');
    const [crmFilter, setCrmFilter] = useState('');
    const [sortBy, setSortBy] = useState('name');
    const [sortOrder, setSortOrder] = useState('asc');
    
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const fetchUniversities = async () => {
        try {
            // Build query parameters
            const params = new URLSearchParams();
            if (searchTerm) params.append('search', searchTerm);
            if (countryFilter) params.append('country', countryFilter);
            if (crmFilter !== '') params.append('crm_enabled', crmFilter);
            if (sortBy) params.append('sort_by', sortBy);
            if (sortOrder) params.append('sort_order', sortOrder);

            const url = `${apiUrl}/universities?${params.toString()}`;
            
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error("Failed to fetch universities");
            }
            const data = await response.json();
            setUniversities(data);
        } catch (error) {
            console.error("Error fetching universities:", error);
            setError("Failed to load universities. Please try again.");
        }
    };

    useEffect(() => {
        fetchUniversities();
    }, [searchTerm, countryFilter, crmFilter, sortBy, sortOrder]);

    const handleDisable = async (universityId) => {
        try {
            const url = `${apiUrl}/crm/${universityId}/deactivate`;
            const response = await fetch(url, {method: "PUT"});

            if (!response.ok) throw new Error("Failed to disable user.");

            setUniversities(universities.map(university => university.id === universityId ? {
                ...university,
                crm_enabled: false
            } : university));
            setFeedbackMessage("CRM disabled successfully.");
        } catch (error) {
            console.error("Error disabling user:", error);
            setFeedbackMessage("Failed to disable CRM. Please try again.");
        }

        setTimeout(() => setFeedbackMessage(null), 3000);
    };

    const handleActivate = async (universityId) => {
        try {
            const url = `${apiUrl}/crm/${universityId}/activate`;
            const response = await fetch(url, {method: "PUT"});

            if (!response.ok) throw new Error("Failed to activate CRM.");

            setUniversities(universities.map(university => university.id === universityId ? {
                ...university,
                crm_enabled: true
            } : university));
            setFeedbackMessage("CRM activated successfully.");
        } catch (error) {
            console.error("Error activating user:", error);
            setFeedbackMessage("Failed to activate CRM. Please try again.");
        }

        setTimeout(() => setFeedbackMessage(null), 3000);
    };

    if (error) {
        return <p className="text-danger">{error}</p>;
    }

    return (
        <div className="table-responsive">
            
            {/* Filter and Sort Controls */}
            <div className="row mb-3">
                <div className="col-md-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search universities..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className="col-md-2">
                    <select
                        className="form-control"
                        value={countryFilter}
                        onChange={(e) => setCountryFilter(e.target.value)}
                    >
                        <option value="">All Countries</option>
                        <option value="United States">United States</option>
                        <option value="Canada">Canada</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="Australia">Australia</option>
                        <option value="Germany">Germany</option>
                        <option value="France">France</option>
                        <option value="Spain">Spain</option>
                        <option value="Italy">Italy</option>
                        <option value="Netherlands">Netherlands</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Norway">Norway</option>
                        <option value="Denmark">Denmark</option>
                        <option value="Finland">Finland</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Austria">Austria</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Ireland">Ireland</option>
                        <option value="New Zealand">New Zealand</option>
                        <option value="Japan">Japan</option>
                        <option value="South Korea">South Korea</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Hong Kong">Hong Kong</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
                <div className="col-md-2">
                    <select
                        className="form-control"
                        value={crmFilter}
                        onChange={(e) => setCrmFilter(e.target.value)}
                    >
                        <option value="">All CRM Status</option>
                        <option value="true">CRM Enabled</option>
                        <option value="false">CRM Disabled</option>
                    </select>
                </div>
                <div className="col-md-2">
                    <select
                        className="form-control"
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                    >
                        <option value="name">Name</option>
                        <option value="country">Country</option>
                        <option value="contact_email">Contact Email</option>
                        <option value="created_on">Created Date</option>
                    </select>
                </div>
                <div className="col-md-2">
                    <select
                        className="form-control"
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                    >
                        <option value="asc">Ascending</option>
                        <option value="desc">Descending</option>
                    </select>
                </div>
                <div className="col-md-1">
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => {
                            setSearchTerm('');
                            setCountryFilter('');
                            setCrmFilter('');
                            setSortBy('name');
                            setSortOrder('asc');
                        }}
                    >
                        Clear
                    </button>
                </div>
            </div>

            <table className="table table-striped">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Admin User</th>
                    <th>Country</th>
                    <th>Contact Email</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {console.log(universities)}
                {universities.map((university) => (
                    <tr key={university.id}>
                        <td>{university.name}</td>
                        <td>{university.user}</td>
                        <td>{university.country}</td>
                        <td>{university.contact_email}</td>
                        <td>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => onEdit(university)}
                            >
                                Edit
                            </button>
                            &nbsp;&nbsp;
                            {university.crm_enabled ?
                                <span>
                                    <button
                                        className={`btn btn-sm btn-warning}`}
                                        onClick={() => handleDisable(university.id)}
                                    >
                                        Disable CRM
                                    </button>
                                    &nbsp;
                                    &nbsp;
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => onEditCRM(university)}
                                    >
                                        Edit CRM
                                    </button>
                                </span>
                                :
                                <button
                                    className={`btn btn-sm btn-success`}
                                    onClick={() => handleActivate(university.id)}

                                >
                                    Activate CRM
                                </button>

                            }


                            &nbsp;&nbsp;
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default UniversityList;